<template>
	<li
		class="menu_item__parent"
		@mouseenter="subMenuChangeDesktop"
		@mouseleave="subMenuChangeDesktop"
		:class="{
      last: last === true,
      'has-children': this.$attrs['has-children'],
      selected: this.$attrs['selected'],
			top: theme === 'top',
			portal: theme === 'portal',
			mobile: type === 'mobile'
    }"
	>
		<div
			class="parent_container"
			:class="[theme,type]"
		>

			<svg
				v-if="theme === 'portal' && type != 'mobile'"
				width="15"
				height="17"
				viewBox="0 0 15 17"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M5.58546 4.32745C5.58546 3.28318 6.432 2.43663 7.47628 2.43663C8.52055 2.43663 9.3671 3.28318 9.3671 4.32745C9.3671 5.37172 8.52055 6.21827 7.47628 6.21827C6.432 6.21827 5.58546 5.37172 5.58546 4.32745ZM7.47628 0.691528C5.46821 0.691528 3.84035 2.31939 3.84035 4.32745C3.84035 6.33552 5.46821 7.96338 7.47628 7.96338C9.48434 7.96338 11.1122 6.33552 11.1122 4.32745C11.1122 2.31939 9.48434 0.691528 7.47628 0.691528ZM4.02431 11.7815C4.88684 10.919 6.05667 10.4345 7.27645 10.4345H7.67608C8.89587 10.4345 10.0657 10.919 10.9282 11.7815C11.7702 12.6235 12.252 13.7582 12.2745 14.9464H2.67806C2.70058 13.7582 3.18238 12.6235 4.02431 11.7815ZM7.27645 8.68935C5.59383 8.68935 3.98013 9.35777 2.79034 10.5476C1.60055 11.7374 0.932129 13.3511 0.932129 15.0337C0.932129 15.4734 1.10679 15.895 1.4177 16.206C1.72861 16.5169 2.15029 16.6915 2.58998 16.6915H12.3626C12.5803 16.6915 12.7959 16.6486 12.997 16.5653C13.1981 16.482 13.3809 16.3599 13.5348 16.206C13.6888 16.052 13.8109 15.8693 13.8942 15.6681C13.9775 15.467 14.0204 15.2514 14.0204 15.0337C14.0204 13.3511 13.352 11.7374 12.1622 10.5476C10.9724 9.35777 9.3587 8.68935 7.67608 8.68935H7.27645Z"
					fill="#203136"
				/>
			</svg>

			<svg
				v-if="theme === 'portal' && type === 'mobile'"
				width="21"
				height="24"
				viewBox="0 0 21 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M7.25244 5.455C7.25244 3.54686 8.7993 2 10.7074 2C12.6156 2 14.1624 3.54686 14.1624 5.455C14.1624 7.36314 12.6156 8.91 10.7074 8.91C8.7993 8.91 7.25244 7.36314 7.25244 5.455ZM10.7074 0C7.69473 0 5.25244 2.44229 5.25244 5.455C5.25244 8.46771 7.69473 10.91 10.7074 10.91C13.7202 10.91 16.1624 8.46771 16.1624 5.455C16.1624 2.44229 13.7202 0 10.7074 0ZM5.17851 16.2898C6.64467 14.8237 8.63321 14 10.7067 14C11.7333 14 12.75 14.2022 13.6985 14.5951C14.647 14.988 15.5089 15.5639 16.2348 16.2898C16.9608 17.0158 17.5367 17.8777 17.9296 18.8262C18.3225 19.7747 18.5247 20.7913 18.5247 21.818V22H2.88867V21.818C2.88867 19.7445 3.71235 17.756 5.17851 16.2898ZM10.7067 12C8.10278 12 5.60553 13.0344 3.7643 14.8756C1.92307 16.7169 0.888672 19.2141 0.888672 21.818V24H20.5247V21.818C20.5247 20.5287 20.2707 19.252 19.7773 18.0608C19.2839 16.8696 18.5607 15.7873 17.649 14.8756C16.7374 13.9639 15.655 13.2408 14.4639 12.7474C13.2727 12.254 11.996 12 10.7067 12Z"
					fill="#DDFC70"
				/>
			</svg>

			<div
				class='icon-wrapper'
				v-if="menu_item['menu_icon']"
			>
				<img
					:src="menu_item['menu_icon']"
					:alt="menu_item['title']"
				/>
			</div>

			<template v-if="type != 'mobile'">
				<a
					v-if="menu_item['url']"
					class="menu_item__parent__primary_link"
					:href="localUrlSwap(menu_item['url'])"
					:target="menu_item['target']"
					v-html="menu_item['title']"
					@mouseover="show = true"
					@mouseleave="show = false"
					:class="theme"
				></a>
				<label
					v-else
					class="menu_item__parent__primary_link"
					v-html="menu_item['title']"
				></label>
			</template>

			<svg
				v-if="menu_item['target'] === '_blank' && theme != 'portal'"
				width="15"
				height="20"
				viewBox="0 0 15 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M5.33301 5.05976C5.33301 3.86296 6.30321 2.89276 7.50001 2.89276C8.69681 2.89276 9.66701 3.86296 9.66701 5.05976C9.66701 6.25656 8.69681 7.22676 7.50001 7.22676C6.30321 7.22676 5.33301 6.25656 5.33301 5.05976ZM7.50001 0.892761C5.19864 0.892761 3.33301 2.75839 3.33301 5.05976C3.33301 7.36113 5.19864 9.22676 7.50001 9.22676C9.80138 9.22676 11.667 7.36113 11.667 5.05976C11.667 2.75839 9.80138 0.892761 7.50001 0.892761ZM3.54384 13.6026C4.53234 12.6141 5.87304 12.0588 7.271 12.0588H7.729C9.12696 12.0588 10.4677 12.6141 11.4562 13.6026C12.4211 14.5675 12.9732 15.868 12.9991 17.2298H2.00095C2.02676 15.868 2.57893 14.5675 3.54384 13.6026ZM7.271 10.0588C5.34261 10.0588 3.4932 10.8248 2.12963 12.1884C0.76605 13.552 0 15.4014 0 17.3298C0 17.8337 0.200178 18.317 0.556497 18.6733C0.912818 19.0296 1.39609 19.2298 1.9 19.2298H13.1C13.3495 19.2298 13.5966 19.1806 13.8271 19.0851C14.0576 18.9897 14.2671 18.8497 14.4435 18.6733C14.6199 18.4968 14.7599 18.2874 14.8554 18.0569C14.9509 17.8264 15 17.5793 15 17.3298C15 15.4014 14.2339 13.552 12.8704 12.1884C11.5068 10.8248 9.65739 10.0588 7.729 10.0588H7.271Z"
					fill="#203136"
				/>
			</svg>

			<div
				class="has-children-indicator"
				:class="[menu_item['classes'], type]"
				v-if="menu_item['children'] && hasChildren && window.width > 1240"
			>
				<svg
					fill="none"
					viewBox="0 0 117 68"
				>
					<defs />
					<path
						fill="#fff"
						d="M58.5 68L0 9.70228 9.67228 0 58.5 48.6589 107.328 0 117 9.70228 58.5 68z"
					/>
				</svg>
			</div>

			<div
				class="has-children-indicator"
				:class="[menu_item['classes'], type]"
				v-if="menu_item['children'] && hasChildren && window.width < 1240"
				@click="subMenuChange"
			>
				<svg
					fill="none"
					viewBox="0 0 117 68"
				>
					<defs />
					<path
						fill="#fff"
						d="M58.5 68L0 9.70228 9.67228 0 58.5 48.6589 107.328 0 117 9.70228 58.5 68z"
					/>
				</svg>
			</div>

		</div>
		<transition name="slide-fade">
			<ul
				class="menu__child"
				:class="[menu_item['classes'], type]"
				v-if="subMenu === true && hasChildren"
			>
				<li
					v-for="(menu_child_item, index) in menu_item['children']"
					:key="index"
					:class="menu_child_item.classes"
				><a
						class="child_menu_item"
						:class="[menu_item['classes'], type]"
						:href="localUrlSwap(menu_child_item['url'])"
						:target="menu_child_item['target']"
						v-html="menu_child_item['title']"
					></a></li>
			</ul>
		</transition>
	</li>
</template>

<script>
import ExternalLink from '../../images/external_link.svg';

export default {
	data() {
		return {
			show: false,
			subMenu: false,
			isScrolled: false,
			externalLink: ExternalLink,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		menu_item: {},
		selected: {},
		currentMenuItem: {
			type: Boolean,
			default: false,
		},
		menuLength: {
			default: 0,
		},
		menuNumber: {
			default: 0,
		},
		theme: {
			default: 'light',
		},
		last: {},
		hasChildren: {},
		type: {},
	},

	computed: {},

	watch: {
		show() {
			this.isScrolled = true;
		},
	},

	methods: {
		didScroll() {
			this.isScrolled = window.scrollY > this.topScrollThreshold;
		},

		localUrlSwap(value) {
			if (window.location.host === 'localhost:3000') {
				return value.replace('savant-energy.test', 'localhost:3000');
			} else {
				return value;
			}
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		subMenuChange() {
			this.subMenu = !this.subMenu;
		},

		subMenuChangeDesktop() {
			if (this.window.width > 1240) {
				this.subMenu = !this.subMenu;
			}
		},
	},
	name: 'MenuItem',
	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.didScroll);
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
	},

	mounted() {
		this.handleResize();
	},

	updated() {
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.parent_container {
	position: relative;
	z-index: 200;
	display: flex;
	column-gap: 10px;
	padding: 18px 20px;
	z-index: 10;
	width: 100%;
	justify-content: space-between;
	align-items: center;

	&:hover {
		cursor: pointer;

		.has-children-indicator {
			svg {
				transition: 0.2s ease all;
				transform: rotate(180deg);

				path {
					fill: var(--cobalt);
				}
			}

			&.portal_logins {
				svg {
					path {
						fill: var(--cobalt);
					}
				}

				&.mobile {
					svg {
						path {
							fill: var(--cobalt);
						}
					}
				}
			}

			.mobile_menu_nav & {
				svg {
					path {
						fill: var(--cobalt);
					}
				}
			}
		}
	}

	&.top {
		align-self: self-end;
		padding: 10px 0 10px 0;
		width: auto;

		.menu_item__parent {
			height: auto;
		}

		.icon-wrapper {
			display: flex;
		}
	}

	&.portal {
		align-self: self-end;
		padding: 10px 0 10px 24px;
		width: auto;

		.menu_item__parent {
			height: auto;
		}

		&.mobile {
			padding: 7px 0 7px 0;

			svg {
				path {
					fill: var(--cobalt);
				}
			}
		}
	}

	.external_link {
		// margin-top: 2px;

		path {
			stroke: var(--cobalt);
		}
	}

	.child_indicator {
		margin-top: 6px;

		@media (min-width: $tablet) {
			path {
				fill: var(--cobalt);
			}
		}
	}
}

.menu__child {
	position: absolute;
	left: 20px;
	top: 60px;
	padding: 0;
	padding-top: 0;
	width: 270px;
	background: var(--white);
	border-right: 1px solid var(--medium-grey);
	border-bottom: 1px solid var(--medium-grey);
	border-left: 1px solid var(--medium-grey);
	z-index: 999;

	&.portal_logins {
		left: unset;
		right: 0;
		top: 38px;
		padding: 0;
		padding-top: 0;
		width: 160px;

		&.mobile {
			position: absolute;
			top: 24px;
			gap: 0;
		}
	}

	@media (max-width: $tablet) {
		margin-top: 24px;
		margin-bottom: 8px;
		position: relative;
		width: 100%;
		padding-top: 0;
		display: flex;
		flex-direction: column;
		gap: 10px;
		left: 0;
	}

	li {
		.has-children-indicator {
			width: 10px;
			height: 10px;
			display: flex;
			justify-content: center;
			align-items: center;

			// &:hover {
			// 	svg {
			// 		path {
			// 			fill: red;
			// 		}
			// 	}
			// }

			svg {
				width: 100%;
				transition: 0.2s ease all;
				transform: rotate(0deg);

				path {
					fill: var(--cobalt);
					transition: color 0.2s ease;
				}
			}

			&.portal_logins {
				svg {
					path {
						fill: var(--cobalt);
					}
				}
			}

			&.mobile {
				svg {
					path {
						fill: var(--cobalt);
					}
				}
			}
		}

		@media (max-width: $tablet) {
			background: transparent;
			border-bottom: 0 !important;
			padding: 0 !important;
		}

		&:first-of-type {
			padding-top: 0;

			a {
				padding: 24px 24px 12px;
			}
		}

		&:last-of-type {
			padding-bottom: 0;

			a {
				padding: 12px 24px 24px;
			}
		}

		&:hover {
			cursor: pointer;
		}

		a {
			color: var(--midnight);
			transition: 0.2s ease all;
			padding: 12px 24px;
			background: transparent;
			width: 100%;
			font: normal normal normal 16px/24px var(--primary-font-family);

			&.portal_logins {
				font: normal normal normal 14px / 18px var(--primary-font-family);
				padding: 10px 16px;
			}

			@media (max-width: $tablet) {
				background: transparent;
				padding: 0;
				font: normal normal normal 16px/24px var(--primary-font-family);
			}

			&:hover {
				cursor: pointer;
				color: var(--cobalt);
				transition: 0.2s ease all;

				@media (max-width: $tablet) {
					color: var(--cobalt);
					background: transparent;
				}
			}

			&::before {
				display: none;
			}
		}
	}
}

li {
	display: flex;

	&:hover {
		cursor: pointer;
		color: var(--cobalt);

		a,
		label {
			&::before {
				width: 100%;
				transition: 0.2s ease all;
			}
		}
	}

	a,
	label {
		color: var(--midnight);
		display: flex;
		align-items: center;
		transition: color 0.2s ease;
		align-items: flex-start;
		text-decoration: none;
		position: relative;
		text-indent: 0;

		&:hover {
			/* color: white; */
			text-decoration: underline;
			transition: color 0.2s ease;
			cursor: pointer;
		}
	}

	.has-children-indicator {
		width: 10px;
		height: 10px;
		display: flex;
		justify-content: center;
		align-items: center;

		// &:hover {
		// 	svg {
		// 		path {
		// 			fill: red;
		// 		}
		// 	}
		// }

		svg {
			width: 100%;
			transition: 0.2s ease all;
			transform: rotate(0deg);

			path {
				fill: var(--cobalt);
				transition: color 0.2s ease;
			}
		}

		&.portal_logins {
			svg {
				path {
					fill: var(--cobalt);
				}
			}
		}
	}

	&.menu_item__parent {
		color: var(--midnight);
		font: normal normal normal 16px/24px var(--primary-font-family);
		display: flex;
		height: 100%;
		align-items: center;
		position: relative;

		@media (max-width: $tablet) {
			flex-direction: column;
		}

		a.menu_item__parent__primary_link {
			color: var(--midnight);
			font: normal normal normal 16px/24px var(--primary-font-family);
			position: relative;
			transition: color 0.2s ease;

			&:hover {
				color: var(--cobalt);
				transition: color 0.2s ease;

				.has-children-indicator {
					svg {
						path {
							fill: var(--cobalt);
							transition: color 0.2s ease;
						}
					}
				}
			}

			&.top,
			&.portal {
				color: var(--white);
				font: normal normal normal 14px/18px var(--primary-font-family);

				@media (max-width: $mobile-xl) {
					display: none;
				}
			}
		}

		label.menu_item__parent__primary_link {
			color: var(--cobalt);
			position: relative;
			transition: color 0.2s ease;

			&:hover {
				color: var(--cobalt);
				transition: color 0.2s ease;

				.has-children-indicator {
					svg {
						path {
							fill: var(--cobalt);
							transition: color 0.2s ease;
						}
					}
				}
			}
		}

		&.last {
			/* .parent_container {
				padding: calc(var(--spacer) * 0) 0 0 20px;
			} */

			div.inner_menu_child {
				ul.menu__child {
					display: flex;
					flex-direction: column;
					grid-column: 2 / span 1;
					left: unset;

					li {
						justify-content: flex-end;
					}
				}
			}
		}

		&.has-children {
			position: relative;
		}

		&.top {
			height: unset;

			a.menu_item__parent__primary_link {
				&::before {
					display: none;
				}
			}
		}

		&.portal {
			height: unset;
			position: relative;
			margin-left: 24px;
			padding-left: 0;

			&.mobile {
				margin-left: 0;
			}

			&::before {
				content: '';
				position: absolute;
				left: 0;
				width: 1px;
				background: var(--cobalt);
				height: 20px;
			}

			a.menu_item__parent__primary_link {
				&::before {
					display: none;
				}
			}
		}
	}

	div.inner_menu_child {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		z-index: -10;

		.color-wrapper {
			display: flex;
			width: 100%;
			height: auto;
			padding: 104px 0 50px;
		}
	}
}

.fade-enter-active {
	animation: fade-in 0.25s;
}

.fade-leave-active {
	animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.slide-fade-enter-active {
	transition: all 0.25s ease;
	transition-delay: 0.25s;
}
.slide-fade-leave-active {
	transition: all 0.25s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(20px);
	opacity: 0;
}
</style>
